(() => {
  const syncPlanPrice = (root) => {
    const plan = root.querySelector('[data-selling-plan]');
    const price = root.querySelector('[data-product-price]');
    if (plan && price && plan.selectedOptions[0]) price.textContent = plan.selectedOptions[0].dataset.price;
  };
  document.querySelectorAll('[data-product-view]').forEach(syncPlanPrice);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-view]').forEach(syncPlanPrice);
  });
  const status = (message) => {
    const node = document.getElementById('CartStatus');
    if (node) { node.hidden = false; node.textContent = message; }
  };
  const closeMenu = (focus = false) => {
    const button = document.querySelector('.header__menu');
    const menu = document.getElementById('MobileMenu');
    if (!button || !menu) return;
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    if (focus) button.focus();
  };
  document.addEventListener('click', (event) => {
    const menuButton = event.target.closest('.header__menu');
    if (menuButton) {
      const menu = document.getElementById('MobileMenu');
      if (menu) { menu.hidden = !menu.hidden; menuButton.setAttribute('aria-expanded', String(!menu.hidden)); }
    } else if (event.target.closest('#MobileMenu a') || !event.target.closest('.site-header')) closeMenu();
    const thumb = event.target.closest('[data-gallery-image]');
    if (thumb) {
      const view = thumb.closest('[data-product-view]');
      const image = view.querySelector('#ProductMainImage');
      if (!image) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = thumb.dataset.galleryImage; image.alt = thumb.dataset.imageAlt;
      view.querySelectorAll('[data-gallery-image]').forEach((node) => node.setAttribute('aria-pressed', String(node === thumb)));
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(true); });
  window.matchMedia('(min-width: 1201px)').addEventListener('change', (event) => { if (event.matches) closeMenu(); });

  // Only one POST is ever made: ambiguous network failures must not repeat a purchase action.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.quick-add-form');
    if (!form || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    form.dataset.pending = 'true';
    const button = form.querySelector('button');
    const original = button.textContent;
    button.disabled = true;
    try {
      const response = await fetch(document.body.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        status(typeof error.description === 'string' ? error.description : 'Ürün eklenemedi. Stok ve adet bilgisini kontrol edin.');
        return;
      }
      button.textContent = '✓';
      status('Ürün sepetinize eklendi.');
      try {
        const cartResponse = await fetch(`${document.body.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('cart-count');
        const cart = await cartResponse.json();
        if (!Number.isFinite(cart.item_count)) throw new Error('cart-count');
        document.querySelectorAll('.cart-count').forEach((node) => { node.textContent = cart.item_count; });
      } catch {
        status('Ürün eklendi. Güncel ürün adedini sepet sayfasında görebilirsiniz.');
      }
    } catch {
      status('Bağlantı kesildi. Yeniden eklemeden önce sepetinizi kontrol edin.');
    } finally {
      form.dataset.pending = 'false';
      button.disabled = false;
      setTimeout(() => { if (form.dataset.pending !== 'true') button.textContent = original; }, 1300);
    }
  });

  let variantRequest;
  document.addEventListener('change', async (event) => {
    if (event.target.matches('[data-selling-plan]')) {
      syncPlanPrice(event.target.closest('[data-product-view]'));
      return;
    }
    const select = event.target.closest('[data-option-select]');
    if (!select) return;
    const view = select.closest('[data-product-view]');
    const selectedOption = select.options[select.selectedIndex];
    const url = new URL(selectedOption.dataset.productUrl || view.dataset.productUrl, window.location.origin);
    const values = Array.from(view.querySelectorAll('[data-option-select]'), (node) => node.value);
    url.searchParams.set('option_values', values.join(','));
    const pageUrl = new URL(url);
    url.searchParams.set('section_id', view.dataset.sectionId);
    if (variantRequest) variantRequest.abort();
    const controller = new AbortController(); variantRequest = controller;
    const button = view.querySelector('[data-product-submit]');
    button.disabled = true;
    view.querySelector('input[name="id"]').disabled = true;
    view.setAttribute('aria-busy', 'true');
    const message = view.querySelector('[data-variant-message]');
    message.textContent = 'Seçeneğiniz yükleniyor…';
    const quantity = view.querySelector('input[name="quantity"]').value;
    const planValue = view.querySelector('[data-selling-plan]')?.value;
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('variant');
      const html = await response.text();
      if (controller.signal.aborted) return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-view]');
      if (!next || !next.querySelector('[data-product-submit]')) throw new Error('variant');
      const nextQuantity = next.querySelector('input[name="quantity"]');
      nextQuantity.value = quantity;
      if (!nextQuantity.checkValidity()) nextQuantity.value = nextQuantity.min || '1';
      const nextPlan = next.querySelector('[data-selling-plan]');
      if (nextPlan && Array.from(nextPlan.options).some((option) => option.value === planValue)) nextPlan.value = planValue;
      syncPlanPrice(next);
      view.replaceWith(next);
      history.replaceState({}, '', pageUrl);
      document.getElementById(select.id)?.focus({ preventScroll: true });
      next.querySelector('[data-variant-message]').textContent = 'Seçenek bilgileri güncellendi.';
    } catch (error) {
      if (error.name === 'AbortError') return;
      view.removeAttribute('aria-busy');
      message.textContent = 'Seçenek yüklenemedi. ';
      const retry = document.createElement('a');
      retry.href = pageUrl.href; retry.textContent = 'Seçtiğiniz seçenekle sayfayı yenileyin.';
      message.append(retry);
    }
  });
})();

document.addEventListener('toggle', (event) => {
  const panel = event.target;
  if (!(panel instanceof HTMLDetailsElement) || !panel.open || !panel.parentElement?.matches('.product-information')) return;
  panel.parentElement.querySelectorAll(':scope > details[open]').forEach((other) => { if (other !== panel) other.open = false; });
}, true);
